module.exports = __webpack_public_path__ + "img/Boa-Q.eafcef68.svg";